module.exports = __webpack_public_path__ + "29cd98042159782d980002468af826c7.svg";